import { escapeHtml } from './escapeHtml';
import { escapeHtmlAttr } from './escapeHtmlAttr';

/**
 * Per-card-type serialisation to the exact DOM shape the editor paste pipeline
 * recognises. Verified against the ADF schema `parseDOM` rules in
 * platform/packages/editor/adf-schema/src/schema/nodes/{inline,block,embed}-card.ts:
 *
 * - inlineCard: `a[data-inline-card]` → url from `href` or `data-card-url`.
 * - blockCard:  `a[data-block-card]`  → url from `href`.
 * - embedCard:  ONLY `div[data-embed-card]` → url from `data-card-url`
 *               (there is no anchor parse rule for embed cards, so emitting an
 *               `<a>` here would paste as a plain link instead of an embed).
 *
 * Explicit per-type handling (rather than deriving the attribute from the node
 * type name) so only these known card types can ever emit a card signal.
 */
export const cardToHtml = (
	type: 'inlineCard' | 'blockCard' | 'embedCard',
	safeUrl: string,
	rawUrl: string,
): string => {
	const cardUrl = escapeHtmlAttr(safeUrl);
	if (type === 'embedCard') {
		return `<div data-embed-card="" data-card-url="${cardUrl}"></div>`;
	}
	const dataAttr = type === 'blockCard' ? 'data-block-card' : 'data-inline-card';
	return `<a ${dataAttr}="" data-card-url="${cardUrl}" href="${cardUrl}">${escapeHtml(rawUrl)}</a>`;
};
